export default __webpack_public_path__ + "static/media/hero-animation-01.c78877b2.svg";